import { render, staticRenderFns } from "./TaxResidence.vue?vue&type=template&id=4e8caff5&scoped=true&"
import script from "./TaxResidence.vue?vue&type=script&lang=js&"
export * from "./TaxResidence.vue?vue&type=script&lang=js&"
import style0 from "./TaxResidence.vue?vue&type=style&index=0&id=4e8caff5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8caff5",
  null
  
)

export default component.exports